"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.purgeAll = exports.setCustomerToken = exports.fetchRefreshCustomerToken = exports.fetchResetPasswordSuccess = exports.fetchLoginSuccess = exports.fetchResetPassword = exports.fetchRecovery = exports.fetchRegister = exports.logout = exports.fetchLogin = exports.postAccountVerification = exports.PURGE_ALL = exports.FETCH_CUSTOMER_TOKEN_FAIL = exports.FETCH_CUSTOMER_TOKEN_SUCCESS = exports.FETCH_CUSTOMER_TOKEN = exports.REFRESH_CUSTOMER_TOKEN = exports.SET_CUSTOMER_TOKEN = exports.FETCH_RESET_PASSWORD_SUCCESS = exports.FETCH_RESET_PASSWORD = exports.FETCH_RECOVERY = exports.FETCH_REGISTER = exports.FETCH_LOGIN_SUCCESS = exports.LOGOUT = exports.FETCH_LOGIN = exports.POST_ACCOUNT_VERIFICATION = void 0;

var _router = require("@modules/router");

var _snackbar = require("@modules/snackbar");

var _api = require("@modules/api");

var _state = require("./state");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ROOT = '@@auth';
var POST_ACCOUNT_VERIFICATION = "".concat(ROOT, "/POST_ACCOUNT_VERIFICATION");
exports.POST_ACCOUNT_VERIFICATION = POST_ACCOUNT_VERIFICATION;
var FETCH_LOGIN = "".concat(ROOT, "/FETCH_LOGIN");
exports.FETCH_LOGIN = FETCH_LOGIN;
var LOGOUT = "".concat(ROOT, "/LOGOUT");
exports.LOGOUT = LOGOUT;
var FETCH_LOGIN_SUCCESS = "".concat(ROOT, "/FETCH_LOGIN_SUCCESS");
exports.FETCH_LOGIN_SUCCESS = FETCH_LOGIN_SUCCESS;
var FETCH_REGISTER = "".concat(ROOT, "/FETCH_REGISTER");
exports.FETCH_REGISTER = FETCH_REGISTER;
var FETCH_RECOVERY = "".concat(ROOT, "/FETCH_RECOVERY");
exports.FETCH_RECOVERY = FETCH_RECOVERY;
var FETCH_RESET_PASSWORD = "".concat(ROOT, "/FETCH_RESET_PASSWORD");
exports.FETCH_RESET_PASSWORD = FETCH_RESET_PASSWORD;
var FETCH_RESET_PASSWORD_SUCCESS = "".concat(ROOT, "/FETCH_RESET_PASSWORD_SUCCESS");
exports.FETCH_RESET_PASSWORD_SUCCESS = FETCH_RESET_PASSWORD_SUCCESS;
var SET_CUSTOMER_TOKEN = "".concat(ROOT, "/SET_CUSTOMER_TOKEN");
exports.SET_CUSTOMER_TOKEN = SET_CUSTOMER_TOKEN;
var REFRESH_CUSTOMER_TOKEN = "".concat(ROOT, "/REFRESH_CUSTOMER_TOKEN");
exports.REFRESH_CUSTOMER_TOKEN = REFRESH_CUSTOMER_TOKEN;
var FETCH_CUSTOMER_TOKEN = "".concat(ROOT, "/FETCH_CUSTOMER_TOKEN");
exports.FETCH_CUSTOMER_TOKEN = FETCH_CUSTOMER_TOKEN;
var FETCH_CUSTOMER_TOKEN_SUCCESS = "".concat(ROOT, "/FETCH_CUSTOMER_TOKEN_SUCCESS");
exports.FETCH_CUSTOMER_TOKEN_SUCCESS = FETCH_CUSTOMER_TOKEN_SUCCESS;
var FETCH_CUSTOMER_TOKEN_FAIL = "".concat(ROOT, "/FETCH_CUSTOMER_TOKEN_FAIL");
exports.FETCH_CUSTOMER_TOKEN_FAIL = FETCH_CUSTOMER_TOKEN_FAIL;
var PURGE_ALL = "".concat(ROOT, "/PURGE_ALL");
exports.PURGE_ALL = PURGE_ALL;

var postAccountVerification = function postAccountVerification(token, successMessage) {
  var _next;

  return {
    type: _api.apiActions.CALL_API,
    call: POST_ACCOUNT_VERIFICATION,
    route: "/accounts/verify_email/".concat(token),
    params: (0, _api.apiMakeRequestParams)({}, {
      method: 'POST'
    }),
    next: (_next = {}, _defineProperty(_next, _api.apiActions.CALL_API_SUCCESS, [_router.routerActions.flush, _snackbar.snackbarActions.show.bind(null, {
      message: successMessage
    })]), _defineProperty(_next, _api.apiActions.CALL_API_FAIL, function (_ref) {
      var error = _ref.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next)
  };
};

exports.postAccountVerification = postAccountVerification;

var fetchLogin = function fetchLogin(username, password, redirectRoute, language) {
  var _next2;

  return {
    type: _api.apiActions.CALL_API,
    call: FETCH_LOGIN,
    route: "/auth/login",
    params: (0, _api.apiMakeRequestParams)([{
      key: 'email',
      value: username
    }, {
      key: 'pass',
      value: password
    }]),
    next: (_next2 = {}, _defineProperty(_next2, _api.apiActions.CALL_API_SUCCESS, fetchLoginSuccess), _defineProperty(_next2, _api.apiActions.CALL_API_FAIL, function (_ref2) {
      var error = _ref2.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next2),
    nextArgs: [redirectRoute, language],
    schema: _state.transformCustomerToken
  };
};

exports.fetchLogin = fetchLogin;

var logout = function logout(redirectRoute) {
  return {
    type: LOGOUT,
    redirectRoute: redirectRoute
  };
};

exports.logout = logout;

var fetchRegister = function fetchRegister() {
  var _next3;

  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var successMessage = arguments.length > 1 ? arguments[1] : undefined;
  var language = arguments.length > 2 ? arguments[2] : undefined;
  var redirectRoute = arguments.length > 3 ? arguments[3] : undefined;
  return {
    type: _api.apiActions.CALL_API,
    call: FETCH_REGISTER,
    route: "/accounts/register",
    params: (0, _api.apiMakeRequestParams)({
      email: payload.email,
      locale: language,
      newsletter: payload.newsletters,
      password: payload.password,
      postal_code: payload.postalcode,
      terms_and_cons: payload.policies
    }),
    next: (_next3 = {}, _defineProperty(_next3, _api.apiActions.CALL_API_SUCCESS, [fetchLoginSuccess, _snackbar.snackbarActions.show.bind(null, {
      message: successMessage
    })]), _defineProperty(_next3, _api.apiActions.CALL_API_FAIL, function (_ref3) {
      var error = _ref3.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next3),
    nextArgs: [redirectRoute, language],
    schema: _state.transformCustomerToken
  };
};

exports.fetchRegister = fetchRegister;

var fetchRecovery = function fetchRecovery(email, successMessage) {
  var _next4;

  return {
    type: _api.apiActions.CALL_API,
    call: FETCH_RECOVERY,
    route: "/accounts/reset-password-request",
    params: (0, _api.apiMakeRequestParams)({
      email: email
    }),
    next: (_next4 = {}, _defineProperty(_next4, _api.apiActions.CALL_API_SUCCESS, function () {
      return _snackbar.snackbarActions.show({
        message: successMessage
      });
    }), _defineProperty(_next4, _api.apiActions.CALL_API_FAIL, function (_ref4) {
      var error = _ref4.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next4)
  };
};

exports.fetchRecovery = fetchRecovery;

var fetchResetPassword = function fetchResetPassword(password, token, successMessage, redirectRoute) {
  var _next5;

  return {
    type: _api.apiActions.CALL_API,
    call: FETCH_RESET_PASSWORD,
    route: "/accounts/reset-password",
    params: (0, _api.apiMakeRequestParams)({
      password: password,
      token: token
    }),
    next: (_next5 = {}, _defineProperty(_next5, _api.apiActions.CALL_API_SUCCESS, fetchResetPasswordSuccess), _defineProperty(_next5, _api.apiActions.CALL_API_FAIL, function (_ref5) {
      var error = _ref5.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next5),
    nextArgs: [successMessage, redirectRoute]
  };
};

exports.fetchResetPassword = fetchResetPassword;

var fetchLoginSuccess = function fetchLoginSuccess(customerToken, redirectRoute, language) {
  return {
    type: FETCH_LOGIN_SUCCESS,
    customerToken: customerToken,
    redirectRoute: redirectRoute,
    language: language
  };
};

exports.fetchLoginSuccess = fetchLoginSuccess;

var fetchResetPasswordSuccess = function fetchResetPasswordSuccess(payload, successMessage, redirectRoute) {
  return {
    type: FETCH_RESET_PASSWORD_SUCCESS,
    successMessage: successMessage,
    redirectRoute: redirectRoute
  };
};

exports.fetchResetPasswordSuccess = fetchResetPasswordSuccess;

var fetchRefreshCustomerToken = function fetchRefreshCustomerToken(customerToken) {
  var _next6;

  return {
    type: _api.apiActions.CALL_API,
    call: FETCH_CUSTOMER_TOKEN,
    route: "/auth/refresh-customer-token?customer_token=" + "".concat(encodeURIComponent(customerToken)),
    schema: _state.transformCustomerToken,
    next: (_next6 = {}, _defineProperty(_next6, _api.apiActions.CALL_API_SUCCESS, setCustomerToken), _defineProperty(_next6, _api.apiActions.CALL_API_FAIL, function (_ref6) {
      var error = _ref6.error;
      return [purgeAll, _router.routerActions.flush, _snackbar.snackbarActions.show({
        message: error.literal
      })];
    }), _next6)
  };
};

exports.fetchRefreshCustomerToken = fetchRefreshCustomerToken;

var setCustomerToken = function setCustomerToken(customerToken) {
  return {
    type: SET_CUSTOMER_TOKEN,
    customerToken: customerToken
  };
};

exports.setCustomerToken = setCustomerToken;

var purgeAll = function purgeAll() {
  return {
    type: PURGE_ALL
  };
};

exports.purgeAll = purgeAll;